// extracted by mini-css-extract-plugin
export default {"custom-app-link__external-icon":"E3Ypd_"};